// import {Test} from "./styles";
import { Card, Thumbnail, Typography, Bg, Bg2, Bg3, } from "../EnrollmentEmptyCard/styles";
import { Flex } from "../StyledComponents";
import Valoration from "../EnrollmentEmptyCard/components/Valoration";
import InformationCircleIcon from "../../assets/icons/icon-cool/filled/InformationCircle.svg";
import Icon from "../Icon";
import Difficulty from "../Difficulty";
 
const Component = () => {
    return (
        <Card>
            <Bg />
            <Bg2 />
            <Bg3 />
            <Flex gap={16} justify="space-between" style={{ position: "relative", zIndex: "10" }}>
                <Thumbnail background={""} />
                <Flex gap={8} column>
                    <Flex justify="space-between" align="center">
                        <Typography as="h5" size="sm" width={80} height={16} />
                        <Valoration value={3}/>
                    </Flex>
                    <Typography as="p" size="lg" width={100} height={13}/>
                    <Flex gap={5} align="flex-end">
                        <Flex column gap={3}>
                            <Flex align="center" gap={5}>
                            <Typography as="p" size="xs" width={62} height={13}/>
                            <Icon
                                icon={InformationCircleIcon}
                                size="12px" color="#f1f4f9"
                            />
                            </Flex>
                        </Flex>
                    </Flex>
                    <Flex gap={5} align="flex-end">
                        <Typography as="h5" size="sm" width={100} height={16} />
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    )
}

export default Component;